import script from "./WebAgencyPresentation.vue?vue&type=script&setup=true&lang=js"
export * from "./WebAgencyPresentation.vue?vue&type=script&setup=true&lang=js"

import "./WebAgencyPresentation.vue?vue&type=style&index=0&id=1663519a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1663519a"]])

export default __exports__